var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotsyncIcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notsync_icn",
    transform: "translate(-364 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-remove",
    transform: "translate(364 252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.944 10.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.084,2.084,0,0",
    transform: "translate(0.03 0)",
    fill: "none",
    stroke: "#e52a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2.094,0,0,2.094",
    transform: "translate(0 0.02)",
    fill: "none",
    stroke: "#e52a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H16V16H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(0.715 1.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M2.565,0a2.734,2.734,0,0,0,0,5.458h1.4",
    transform: "translate(0 6.32)",
    fill: "none",
    stroke: "#e52a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.358,6.32C-1.987-.2,7.906-2.813,9.039,4.041a3.891,3.891,0,0,1-.614,7.738H8.359",
    transform: "translate(2.243 0)",
    fill: "none",
    stroke: "#e52a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M7.307,3.653a3.445,3.445,0,0,1-.336,1.505,3,3,0,0,1-.2.373,3.629,3.629,0,0,1-6.24,0,3,3,0,0,1-.2-.373A3.445,3.445,0,0,1,0,3.653a3.653,3.653,0,0,1,7.307,0Z",
    transform: "translate(4.346 7.656)",
    fill: "none",
    stroke: "#e52a2a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotsyncIcn);
export default __webpack_public_path__ + "static/media/notsync_icn.6c6b5677be779aa436d7d3e014409a0b.svg";
export { ForwardRef as ReactComponent };